// utils/uid.js
// export function safeUUID() {
//     const c = globalThis.crypto

//     // randomUUID가 '함수'일 때만 호출
//     if (typeof c?.randomUUID === 'function') return c.randomUUID()

//     // getRandomValues도 '함수'일 때만 사용
//     if (typeof c?.getRandomValues !== 'function') {
//         return `uid-${Date.now()}-${Math.random().toString(16).slice(2)}`
//     }

//     const bytes = c.getRandomValues(new Uint8Array(16))
//     bytes[6] = (bytes[6] & 0x0f) | 0x40
//     bytes[8] = (bytes[8] & 0x3f) | 0x80

//     const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('')
//     return (
//         hex.slice(0, 8) + '-' +
//         hex.slice(8, 12) + '-' +
//         hex.slice(12, 16) + '-' +
//         hex.slice(16, 20) + '-' +
//         hex.slice(20)
//     )
// }


// utils/uid.js
let seq = 0

export function uid(prefix = 'uid') {
    seq = (seq + 1) % Number.MAX_SAFE_INTEGER
    // 시간 + 시퀀스 + 랜덤(충돌 방지)
    return `${prefix}-${Date.now().toString(36)}-${seq.toString(36)}-${performance.now().toString(36).slice(2, 8)}`
}
